import { render, staticRenderFns } from "./ModalMessage.vue?vue&type=template&id=1c5ff666&scoped=true&"
import script from "./ModalMessage.vue?vue&type=script&lang=ts&"
export * from "./ModalMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ModalMessage.vue?vue&type=style&index=0&id=1c5ff666&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ff666",
  null
  
)

export default component.exports